import React from "react";

import useFetchObjectByPost from "../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../Context/InshData";
import { uri } from "../../../help/Api";
import LoadingPage from "../../../services/LoadingPage";
import DiscountCode from "./DiscountCode";
const defaultAutos = {
    Branches: [],
};

export default function DiscountCodeCon() {

  const tb = {
    wait: true,
    other: true,
    DiscountCode:true,
    stor: { ...sto, branchi:sto.branchi},
    parms:{
      iempid: sto.empi,
      tname: "discount_code",
      branch:  sto.branchi
    }
};

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
  );

  if (
    fetchAll ||!AutoOptions?.DiscountCode
  )
    return <LoadingPage />;

  return (
    <DiscountCode
      {...{
        AutoOptions: AutoOptions?.DiscountCode ? AutoOptions : defaultAutos,
      }}
    />
  );
}
